"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[90959],{

/***/ 90959:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CSSAnimation": function() { return /* binding */ CSSAnimation; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10253);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var hooks_useIntersectionItem__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(30109);




var CSSAnimation = function(param) {
    var children = param.children, intersectedClasses = param.intersectedClasses;
    var ref = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)((0,hooks_useIntersectionItem__WEBPACK_IMPORTED_MODULE_2__/* .useIntersectionItem */ .b)(0.2), 2), intersectRef = ref[0], isIntersected = ref[1];
    if (isIntersected) {
        return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function(child) {
            return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
                className: "".concat(child.props.className, " ").concat(intersectedClasses)
            });
        });
    }
    return react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function(child) {
        return /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.cloneElement)(child, {
            ref: intersectRef
        });
    });
};
CSSAnimation.propTypes = {
    children: prop_types__WEBPACK_IMPORTED_MODULE_3___default().instanceOf(Object).isRequired,
    intersectedClasses: prop_types__WEBPACK_IMPORTED_MODULE_3___default().oneOfType([
        (prop_types__WEBPACK_IMPORTED_MODULE_3___default().string),
        prop_types__WEBPACK_IMPORTED_MODULE_3___default().arrayOf((prop_types__WEBPACK_IMPORTED_MODULE_3___default().string)), 
    ])
};


/***/ }),

/***/ 30109:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ useIntersectionItem; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_use__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(80621);


var useIntersectionItem = function() {
    var percentIntersection = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0.2;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false), isIntersected = ref[0], setIntersected = ref[1];
    var intersectRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    var intersection = (0,react_use__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(intersectRef, {
        root: null,
        rootMargin: "0px",
        threshold: percentIntersection
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (intersectRef && intersectRef.current) {
            if (intersection && intersection.intersectionRatio >= percentIntersection) {
                setIntersected(true);
            }
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        intersection
    ]);
    return [
        intersectRef,
        isIntersected
    ];
};


/***/ }),

/***/ 80621:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);

var useIntersection = function (ref, options) {
    var _a = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), intersectionObserverEntry = _a[0], setIntersectionObserverEntry = _a[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function () {
        if (ref.current && typeof IntersectionObserver === 'function') {
            var handler = function (entries) {
                setIntersectionObserverEntry(entries[0]);
            };
            var observer_1 = new IntersectionObserver(handler, options);
            observer_1.observe(ref.current);
            return function () {
                setIntersectionObserverEntry(null);
                observer_1.disconnect();
            };
        }
        return function () { };
    }, [ref.current, options.threshold, options.root, options.rootMargin]);
    return intersectionObserverEntry;
};
/* harmony default export */ __webpack_exports__["Z"] = (useIntersection);


/***/ })

}]);